// extracted by mini-css-extract-plugin
module.exports = {"main":"react-mobile-datepicker_main__iDkdt"};